// phonics_data_lt22.js
// Letter Teams L22 - L22 Long Vowel Sounds a, au, aw
// 路由：/phonics/lt22

const MEDIA_BASE = '/media/phonics/lt22';
const V = 'v1';

export const letterDataLt22 = {
  id: 'lt22',
  letter: 'L22',
  title: 'L22 Long Vowel Sounds a, au, aw',
  mediaBase: MEDIA_BASE,

  part1Video: { src: `${MEDIA_BASE}/part1.mp4?${V}` },
  part3Video: { src: `${MEDIA_BASE}/part3.mp4?${V}` },
  reviewPic: { src: `${MEDIA_BASE}/review.png?${V}` },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "It is August.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "The pals like to draw.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Green draws a hawk.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "It has big claws.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Yellow, what did you draw?", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "This is Paul.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "He is on the lawn.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Blue draws a pot of sauce.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Red, what will you draw?", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "I don't know.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "I will draw a ball.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "That is a small ball.", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "It is small like Red.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Oh, I know what to draw.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "Red draws for a long time.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "What is it?", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "It is me.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "And I am very tall.", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
      ],
    },
  ],
};
